import React, { useEffect, useRef, useState, useCallback } from 'react';
import dropin from 'braintree-web-drop-in';
const BraintreeDropin = ({
  authorizationToken,
  locale,
  renderSubmitButton,
  handlePaymentMethod,
  onCreate,
  onError,
  paymentOptionPriority,
  googlePay
}) => {
  const containerRef = useRef(null);
  const instanceRef = useRef(null);
  const [isReady, setIsReady] = useState(false);
  const [isRequesting, setIsRequesting] = useState(false);
  const [canRequestPayment, setCanRequestPayment] = useState(false);
  useEffect(() => {
    if (!authorizationToken || !containerRef.current || instanceRef.current) {
      return;
    }
    const options = {
      authorization: authorizationToken,
      container: containerRef.current,
      locale: locale || 'en',
      paymentOptionPriority: paymentOptionPriority || (googlePay ? ['card', 'googlePay'] : ['card'])
    };
    if (googlePay) {
      options.googlePay = googlePay;
    }
    dropin.create(options, (createErr, instance) => {
      if (createErr) {
        onError?.(createErr);
        return;
      }
      instanceRef.current = instance;
      setIsReady(true);
      // Set up payment method requestable callbacks
      instance.on('noPaymentMethodRequestable', () => {
        setCanRequestPayment(false);
      });
      instance.on('paymentMethodRequestable', () => {
        setCanRequestPayment(true);
      });
      onCreate?.(instance);
    });
    return () => {
      if (instanceRef.current) {
        instanceRef.current.teardown().catch(() => {});
        instanceRef.current = null;
        setIsReady(false);
        setCanRequestPayment(false);
      }
    };
  }, [authorizationToken, locale]);
  const requestPaymentMethod = useCallback((event) => {
    event.preventDefault();
    if (!instanceRef.current || isRequesting) return;
    setIsRequesting(true);
    instanceRef.current.requestPaymentMethod((err, payload) => {
      setIsRequesting(false);
      if (err) {
        onError?.(err);
        return;
      }
      handlePaymentMethod?.(payload);
    });
  }, [isRequesting, onError, handlePaymentMethod]);
  const SubmitButton = renderSubmitButton ? renderSubmitButton({
    onClick: requestPaymentMethod,
    isDisabled: !isReady || isRequesting || !canRequestPayment
  }) : null;
  return (
    <div>
      <div ref={containerRef} />
      {SubmitButton && (
        <div style={{ textAlign: 'right' }}>
          {SubmitButton}
        </div>
      )}
    </div>
  );
};
export default BraintreeDropin;